import {
  Button,
  Card,
  CardContent,
  Checkbox,
  FormControlLabel,
  FormHelperText,
  Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import React, { useEffect, useRef, useState } from "react";
import DropdownComponent from "../Dropdown/DropdownComponent";
import { RemoteAdFormat } from "../../Constants/DropdownConstants";
import DraggableFeeds from "../../Pages/OutboundFeedsPage/DraggableFeeds";
import {
  addOutboundTemplate,
  getOutboundTemplates,
} from "../../Services/API/OutboundTemplates";
import LoadingBar from "../LoadingBar/LoadingBar";
import { StyledTextField } from "../TextField/TextField";
import prettifyXml from "prettify-xml/dist";

const useStyles = makeStyles((theme) => ({
  root: {
    [theme.breakpoints.down("sm")]: {
      width: "100%",
    },
    justifyContent: "space-between",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    maxHeight: "80vh",
  },
  itemIcon: {
    paddingRight: "15px",
    minWidth: "20px",
    lineHeight: "10px",
  },
  error: {
    color: theme.palette.error.main,
  },
  textField: {
    "& .Mui-error": {
      color: theme.palette.error.main,
    },
    "& .MuiFormHelperText-root": {
      color: theme.palette.error.main,
    },
    "& .MuiInput-underline.Mui-error:after": {
      borderBottomColor: theme.palette.error.main,
    },
  },
}));

export default function OutboundFeedsTemplateModal({
  openModal,
  setData,
  setShowSignifier,
  setShowError,
  allFields,
}) {
  const classes = useStyles();

  const [showInputError, setShowInputError] = useState(false);
  const [custom, setCustom] = useState(false);
  const [mainOuterWrapper, setMainOuterWrapper] = useState("");
  const [jobDataWrapper, setJobDataWrapper] = useState("");
  const [fieldsOrder, setFieldsOrder] = useState(allFields);
  const { current: fields } = useRef(allFields);
  const [name, setName] = useState("");
  const [includeHeader, setIncludeHeader] = useState(false);
  const [mainNodeName, setMainNodeName] = useState("");
  const [jobDataNodeName, setJobDataNodeName] = useState("");
  const [addProcessing, setAddProcessing] = useState(false);
  const [remoteFormat, setRemoteFormat] = useState(0);

  function handleOnDragEnd(result) {
    if (!result.destination) return;
    const items = Array.from(fieldsOrder);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);

    setFieldsOrder(items);
  }

  function handleInputChange(index, e) {
    const items = Array.from(fieldsOrder);
    items[index].val = e.target.value;

    setFieldsOrder(items);
  }

  const checkAllEntered = () => {
    if (!custom) {
      if (
        name === "" ||
        mainNodeName === "" ||
        jobDataNodeName === "" ||
        returnFields(fieldsOrder).length === 0
      ) {
        return false;
      }
    } else {
      if (name === "" || mainOuterWrapper === "" || jobDataWrapper === "") {
        return false;
      }
    }
    return true;
  };

  const convertDate = (date) => {
    var newDate = new Date(date).toLocaleDateString("en-US");
    return newDate;
  };

  const submitData = () => {
    if (checkAllEntered()) {
      setAddProcessing(true);
      addOutboundTemplate(data).then(() => {
        getOutboundTemplates().then((res) => {
          setShowSignifier(true);
          if (res) {
            for (var i in res) {
              res[i].customString = res[i].isCustom ? "Yes" : "No";
              res[i].headerString = res[i].includeHeaderData ? "Yes" : "No";
              res[i].dateCreated = convertDate(res[i].dateCreated);
              res[i].dateLastUpdated = convertDate(res[i].dateLastUpdated);
            }
            setData(res);
            openModal(false);
          } else {
            setShowError(true);
          }
          setAddProcessing(false);
        });
      });
    } else {
      setShowInputError(true);
    }
  };

  const returnFields = (order) => {
    var retVal = [];
    for (var i in order) {
      if (order[i].val !== "" && order[i].val !== undefined) {
        var newField = {
          FieldID: order[i].id,
          Name: order[i].val,
          Order: retVal.length + 1,
        };
        retVal.push(newField);
      }
    }
    return retVal;
  };

  // on first render, avoid issues with the mui textfield placeholder by ensuring field values are not undefined.
  useEffect(() => {
    const items = Array.from(fields);
    for (var i in items) {
      items[i].val =
        items[i].outboundFeedFields[0] !== undefined
          ? items[i].outboundFeedFields[0].name
          : "";
    }
    setFieldsOrder(items);
  }, [fields]); // fields is a stable reference (useRef) which prevents an infinitely looping useEffect.

  const data = {
    Name: name,
    IsCustom: custom,
    IncludeHeaderData: includeHeader,
    MainNodeName: mainNodeName,
    JobDataNodeName: jobDataNodeName,
    MainOuterWrapperString: custom ? mainOuterWrapper : null,
    JobDataOuterWrapperString: custom ? jobDataWrapper : null,
    OutboundFeedFields: custom ? [] : returnFields(fieldsOrder),
    RemoteFormat: remoteFormat,
  };

  return (
    <div className={classes.root}>
      <LoadingBar loading={addProcessing} />
      <Grid>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid xs={12} sm={12} item>
                <p>Add Outbound Feed Template</p>
              </Grid>
              <Grid xs={12} sm={6} item>
                <StyledTextField
                  InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                  placeholder="Name"
                  label="Name"
                  variant="standard"
                  fullWidth
                  required
                  value={name}
                  error={showInputError && name === ""}
                  className={classes.textField}
                  onChange={(e) => setName(e.target.value)}
                />
                {showInputError && name === "" && (
                  <FormHelperText className={classes.error}>
                    Name Required
                  </FormHelperText>
                )}
              </Grid>
              <Grid item xs={12} sm={6}>
                <DropdownComponent
                  currValue={RemoteAdFormat.find((obj) => {
                    return obj.Value === remoteFormat;
                  })}
                  items={RemoteAdFormat}
                  property="Name"
                  handleChange={(remoteAdObject) =>
                    setRemoteFormat(remoteAdObject.Value)
                  }
                  title="Select Remote Format"
                />
              </Grid>
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={includeHeader}
                      onChange={() => setIncludeHeader(!includeHeader)}
                    />
                  }
                  label="Header Data"
                />
              </Grid>
              <Grid xs={12} sm={12} item>
                <FormControlLabel
                  control={
                    <Checkbox
                      color="primary"
                      checked={custom}
                      onChange={() => setCustom(!custom)}
                    />
                  }
                  label="Custom"
                />
              </Grid>
              {custom ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <FormHelperText
                      style={{
                        color: "rgba(255,0,0,.7)",
                        marginBottom: "-20px",
                        marginTop: "20px",
                      }}
                    >
                      Available Fields
                    </FormHelperText>
                    <Button
                      style={{ marginTop: "20px" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                      onClick={() =>
                        setMainOuterWrapper(mainOuterWrapper + "[[data]]")
                      }
                    >
                      Job Data Container
                    </Button>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Main Outer Wrapper"
                      label="Main Outer Wrapper"
                      variant="standard"
                      fullWidth
                      required
                      value={mainOuterWrapper}
                      error={showInputError && mainOuterWrapper === ""}
                      className={classes.textField}
                      onChange={(e) => setMainOuterWrapper(e.target.value)}
                    />
                    {showInputError && mainOuterWrapper === "" && (
                      <FormHelperText className={classes.error}>
                        Main Outer Wrapper Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormHelperText
                      style={{ marginTop: "20px", marginBottom: "-20px" }}
                    >
                      Available Fields
                    </FormHelperText>
                  </Grid>
                  {allFields.map((field, index) => (
                    <Grid item xs={6} sm={2}>
                      <Button
                        style={{
                          width: "100%",
                          height: "60px",
                          marginTop: "20px",
                        }}
                        type="submit"
                        variant="contained"
                        color="primary"
                        onClick={() =>
                          setJobDataWrapper(
                            jobDataWrapper + "[[" + field.dataFieldName + "]]"
                          )
                        }
                      >
                        {field.name}
                      </Button>
                    </Grid>
                  ))}
                  <Grid item xs={12} sm={12}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Job Data Wrapper"
                      label="Job Data Wrapper"
                      variant="standard"
                      fullWidth
                      required
                      multiline
                      value={prettifyXml(jobDataWrapper, { newline: '\n' })}
                      error={showInputError && jobDataWrapper === ""}
                      className={classes.textField}
                      onChange={(e) => setJobDataWrapper(e.target.value)}
                    />
                    {showInputError && jobDataWrapper === "" && (
                      <FormHelperText className={classes.error}>
                        Job Data Wrapper Required
                      </FormHelperText>
                    )}
                  </Grid>
                </>
              ) : (
                <>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Main Node Name"
                      label="Main Node Name"
                      variant="standard"
                      fullWidth
                      required
                      value={mainNodeName}
                      error={showInputError && mainNodeName === ""}
                      className={classes.textField}
                      onChange={(e) => setMainNodeName(e.target.value)}
                    />
                    {showInputError && mainNodeName === "" && (
                      <FormHelperText className={classes.error}>
                        Main Node Required
                      </FormHelperText>
                    )}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <StyledTextField
                      InputLabelProps={{ style: { color: "rgba(0,0,0,.6)" } }}
                      placeholder="Job Data Node Name"
                      label="Job Data Node Name"
                      variant="standard"
                      fullWidth
                      required
                      value={jobDataNodeName}
                      error={showInputError && jobDataNodeName === ""}
                      className={classes.textField}
                      onChange={(e) => setJobDataNodeName(e.target.value)}
                    />
                    {showInputError && jobDataNodeName === "" && (
                      <FormHelperText style={{ color: "rgba(255,0,0,.7)" }}>
                        Job Data Node Required
                      </FormHelperText>
                    )}
                  </Grid>
                  {showInputError && returnFields(fieldsOrder).length === 0 && (
                    <FormHelperText style={{ color: "rgba(255,0,0,.7)" }}>
                      At Least One Field Required
                    </FormHelperText>
                  )}
                  <DraggableFeeds
                    handleOnDragEnd={handleOnDragEnd}
                    items={fieldsOrder}
                    handleInputChange={handleInputChange}
                  />
                </>
              )}
              <Grid item xs={12} sm={12} container justifyContent="flex-end">
                <Button
                  style={{ color: "#82B288", marginTop: "20px" }}
                  type="submit"
                  variant="outlined"
                  disabled={addProcessing}
                  onClick={() => openModal(false)}
                >
                  Cancel
                </Button>
                <Button
                  style={{ marginTop: "20px", marginLeft: "20px" }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  disabled={addProcessing}
                  onClick={() => submitData()}
                >
                  Save
                </Button>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </div>
  );
}
